import React from "react";

//BinaryForge Components
import { Field } from "../../";

//Helpers
import { getUiDateTime } from "../../../helpers/DateUtils";

const DeviceDetailsDiagnosticsSection = ({ t, viewModel, deviceTsFormat, onToggleDeviceTimestampFormat }) => {
	const { reportedState, deviceInfo } = viewModel.diagnostics;

	return (
		<div className="card">
			<header>
				<h3>Diagnostics</h3>
			</header>
			<div className="grid columns-2 gapCol-medium aItems-start">
				<div className="grid columns-2-AutoFree gapCol-small gapRow-xsmall">
					<Field label={t("device.state.firmware")} response={reportedState?.firmware_version} highlight />
					<Field label={t("device.state.hardware")} response={reportedState?.hardware_version} highlight />
					<Field label={t("device.state.wifiSsid")} response={reportedState?.wifi?.ssid} highlight />
					<Field
						label={t("device.state.timestamp")}
						highlight
						response={
							<div onClick={onToggleDeviceTimestampFormat}>
								{deviceTsFormat
									? getUiDateTime(reportedState?.device_timestamp, "d MMM yyyy, HH:mm:ss")
									: reportedState?.device_timestamp}
							</div>
						}
						responseUnit={!deviceTsFormat && " secs"}
						responseClass={["flex"]}
					/>
				</div>
				<div className="grid columns-2-AutoFree gapCol-small gapRow-xsmall">
					<Field label={t("common.createdAt")} response={getUiDateTime(deviceInfo?.createdAt)} highlight />
				</div>
			</div>
		</div>
	);
};

export default DeviceDetailsDiagnosticsSection;
